import axiosInstance from "./axiosInstance";

export const getTemporadas = async (year) => {
    return await axiosInstance.get(
        year ? `${process.env.REACT_APP_BASE_URL}/temporadas?year=${year}` : `${process.env.REACT_APP_BASE_URL}/temporadas`,
        { withCredentials: true }
    );
};

export const postTemporada = async (temporada) => {
    return await axiosInstance.post(
        `${process.env.REACT_APP_BASE_URL}/temporadas`,
        temporada,
        { withCredentials: true }
    );
}

export const putTemporada = async (temporada) => {
    return await axiosInstance.put(
        `${process.env.REACT_APP_BASE_URL}/temporadas`,
        temporada,
        { withCredentials: true }
    );
}

export const deleteTemporada = async (temporadaId) => {
    return await axiosInstance.delete(
        `${process.env.REACT_APP_BASE_URL}/temporadas?id=${temporadaId}`,
        { withCredentials: true }
    );
}

export const getMaxYear = async () => {
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/temporadas/maxYear`,
        { withCredentials: true }
    );
}